var HSN = window.HSN || {};
HSN.Template = HSN.Template || {};

(function ($) {
    "use strict";

    HSN.Template.MatrixOptions = function () {
        var application;
        var container;
        var events;
        var matrixGroupOptions;

        function init(config) {
            application = config.application;
            container = $(config.container);

            var eventScope = 'HSN.MatrixOptions';
            events = {};

            matrixGroupOptions = $('.group-options', container);

            matrixGroupOptions.on('click', 'input', handleGroupOptionClickEvent);

            if (!hasMatrixOptionSelected(container)) {
                $('select.variant-selector', container).hide(0);
                $('.tabs', container).hide(0);
            }
        }

        function hasMatrixOptionSelected(container) {
            return ($('.matrix-options a', container).hasClass("selected") || $('select.matrix-selector option:selected', container).length);
        }

        function destroy() {
            matrixGroupOptions.off();

            application = container = events = matrixGroupOptions = null;
        }

        function handleGroupOptionClickEvent(e) {
            var groupKey = $(this).val();
            var matrixGroup = $('.' + groupKey, container);
            matrixGroup.addClass('active').siblings().removeClass('active');
            $('.matrix-selection-error, .errors-pd').remove();
        }

        return {
            init: init,
            destroy: destroy,
            EVENT: events,
        };
    }();

})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/HSN/Template/MatrixOptions.js